import React, { useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import DisabledImage from "../../../src/Resources/Images/disable.png";
import ActiveImage from "../../../src/Resources/Images/ActiveImage.png";

import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import { visuallyHidden } from "@mui/utils";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Drawer from "@mui/material/Drawer";
import ConfirmBox from "../../UiComponents/ConfirmBox/ConfirmBox";
import { GetUser, GetUserFindbyId, GetClient } from "../../Service/_index";
import Badge from "@mui/material/Badge";
import Stack from "@mui/material/Stack";
import FilterListIcon from "@mui/icons-material/FilterList";
import FilterBox from "../../UiComponents/FilterBox/FilterBox";
import Switch from "@mui/material/Switch";
import AddUser from "./AddUser";
import { getLabelForValue } from "../../Shared/CommonConstant";
import {
  RemoveRedEyeIcon,
  SearchIcon,
  DeleteIcon,
  CloudOffIcon,
  AddIcon,
  NotInterestedIcon,
  DoneOutlineIcon,
  EditIcon,
} from "../../Resources/Icons/icons";
import Loader from "../../UiComponents/Loader/Loader";
import { checkUserType } from "../../Shared/CommonConstant";
import { DeleteBranch, UpdateUser } from "../../Service/_index";

import MasterCommonTable from "../../UiComponents/CommonTable/MasterCommonTable";
import { Divider } from "@mui/material";

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const FilterOption = [
  {
    label: "All Data",
    isEnabled: "all",
  },
  {
    label: "ActiveData",
    isEnabled: "true",
  },
  {
    label: "In ActiveData",
    isEnabled: "false",
  },
];
const headCells = [
  {
    id: "name",
    placeMent: true,
    disablePadding: false,
    label: "Name",
    minWidth: "150px",
  },
  {
    id: "mobileNumber",
    placeMent: true,
    disablePadding: false,
    label: "Mobile",
    minWidth: "150px",
  },
  {
    id: "email",
    placeMent: true,
    disablePadding: false,
    label: "Email",
    minWidth: "150px",
  },
  {
    id: "password",
    placeMent: true,
    disablePadding: false,
    label: "Password",
    minWidth: "150px",
  },
  {
    id: "branchManager",
    placeMent: true,
    disablePadding: false,
    label: "Branch",
    minWidth: "150px",
  },
  {
    id: "userType",
    placeMent: true,
    disablePadding: false,
    label: "User Type",
    minWidth: "150px",
  },
  //   {
  //     id: "action",
  //     placeMent: false,
  //     disablePadding: false,
  //     label: "Action",
  //     minWidth: "150px",
  //   },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells?.map((headCell) => (
          <TableCell
            className="TableHeader"
            key={headCell.id}
            align={headCell.placeMent ? "left" : "center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ fontSize: "16px", fontWeight: 600 }}
            style={{ minWidth: headCells.minWidth }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
};

const ManageUser = () => {
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [selectedData, setSelectedData] = React.useState({});
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [user, setUser] = React.useState([]);
  const [openActiveConfirmBox, setOpenActiveConfirmBox] = useState(false);
  const [activeBoolean, setActiveBoolean] = useState();
  const [viewUserDetails, setViewUserDetails] = useState(false);
  const [openLoader, setOpenLoader] = useState(false);
  const [filter, setFilter] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [searchText, setSearchText] = useState("");
  const [tableConfig, setTableConfig] = useState({
    isAction: true,
    isView: true,
    isEdit: true,
    // isDelete: true,
    isSearch: true,
    isSwitch: true,
  });

  const FilteredData = user.filter((el) => {
    const searchTerm = searchText.toLowerCase();
    const userDetails = `${el?.name},${el?.mobile},${el?.email}`.toLowerCase();
    return userDetails.includes(searchTerm);
  });

  const visibleRows = React.useMemo(
    () => stableSort(filter.fn(user), getComparator(order, orderBy))
    // ?.slice(
    //     page * rowsPerPage,
    //     page * rowsPerPage + rowsPerPage
    //   ),
    // [order, orderBy, page, rowsPerPage, filter, user]
  );

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - user.length) : 0;

  // SUPER_ADMIN: choose whose users to see, from the Filters panel. It starts
  // EMPTY = every admin's users (he has none of his own); picking an admin shows
  // just theirs. His own name (and any super admin) is not offered. Everyone else
  // only ever sees their own and has no Filters button.
  const isSuperAdmin = sessionStorage.getItem("roleId") === "SUPER_ADMIN";
  const ownClientId = sessionStorage.getItem("clientID") || "";
  const [adminOptions, setAdminOptions] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  // What the panel currently shows, and what the table is actually loaded with.
  const [selectedAdmin, setSelectedAdmin] = useState(isSuperAdmin ? "" : ownClientId);
  const [adminFilter, setAdminFilter] = useState(isSuperAdmin ? "ALL" : ownClientId);
  const [applyTick, setApplyTick] = useState(0);
  React.useEffect(() => {
    if (!isSuperAdmin) return;
    GetClient().then((res) => {
      // FilterBox identifies an option by `_id`.
      setAdminOptions(
        (res?.data || [])
          .filter(
            (c) =>
              String(c._id) !== String(ownClientId) &&
              String(c.roleId || "").trim().toUpperCase() !== "SUPER_ADMIN"
          )
          .map((c) => ({
            _id: c._id,
            value: c._id,
            label: c.name || c.client || c.email || c._id,
          }))
      );
    });
  }, []);
  const adminNameOf = (clientId) =>
    adminOptions.find((o) => o._id === String(clientId))?.label || "-";
  // The Admin column only helps when several admins' users are on screen.
  const showAdminColumn = isSuperAdmin && adminFilter === "ALL";

  // FilterBox calls this after a pick; the value is read in the effect below
  // (not here) so it is never a stale one.
  const handleSaveAllFilter = () => setApplyTick((t) => t + 1);
  React.useEffect(() => {
    if (applyTick === 0) return;
    // Un-picking the admin falls back to every admin's users, the default.
    setAdminFilter(selectedAdmin || "ALL");
  }, [applyTick]);
  const handleClearAllState = () => {
    setSelectedAdmin("");
    setAdminFilter(isSuperAdmin ? "ALL" : ownClientId);
  };
  const filterBoxData = React.useMemo(
    () => [
      {
        id: 1,
        label: "Select Admin",
        data: adminOptions,
        setState: setSelectedAdmin,
        value: selectedAdmin,
        type: "input",
        variation: "single",
      },
    ],
    [adminOptions, selectedAdmin]
  );
  // the default (every admin's users) is not "a filter"; a picked admin is
  const activeFiltersCount = isSuperAdmin && adminFilter !== "ALL" ? 1 : 0;

  const GetData = () => {
    const requesttype = "TABLE";
    setOpenLoader(true);
    GetUser({
      isAscending: false,
      requesttype,
      // Own users = no parameter at all, exactly the old request.
      adminClientId: isSuperAdmin && adminFilter !== ownClientId ? adminFilter : undefined,
    }).then((res) => {
      setOpenLoader(false);
      const modifiedUserData = (res?.data || []).map((e) => {
        return {
          ...e,
          branchManager: e?.branchManager?.branchId?.branchName,
        };
      });
      setUser(modifiedUserData);
    });
  };
  React.useEffect(() => {
    GetData();
  }, [adminFilter]);

  const UserType = sessionStorage.getItem("userType");
  const [isAllow, setIsAllow] = useState({});
  React.useEffect(() => {
    const isallowObj = checkUserType(UserType);
    setIsAllow(isallowObj);
  }, []);

  const onSearch = (e) => {
    let target = e.target;
    setFilter({
      fn: (items) => {
        if (target.value == "") return items;
        else
          return items.filter((el) =>
            `${el?.name},${el?.email},${el?.mobileNumber},${el?.password},${el?.userType},${el?.branchManager}`
              .toLowerCase()
              .includes(target.value.toLowerCase())
          );
      },
    });
  };

  const GetActiveData = () => {
    GetUser({ isAscending: false }).then((res) => {
      setUser(res.data.filter((item) => item.isEnabled === true));
    });
  };
  const GetInActiveData = () => {
    GetUser({ isAscending: false }).then((res) => {
      setUser(res.data.filter((item) => item.isEnabled === false));
    });
  };

  const CreateUserData = () => {
    setSelectedData({});
    setOpenDrawer(true);
    setViewUserDetails(false);
  };
  const EditUserData = (row) => {
    setOpenLoader(true);
    GetUserFindbyId(row._id).then((res) => {
      setOpenLoader(false);
      setSelectedData(res.data);
      setViewUserDetails(false);
      setOpenDrawer(true);
    });
  };

  const ViewUserData = (row) => {
    setOpenLoader(true);
    GetUserFindbyId(row._id).then((res) => {
      setOpenLoader(false);
      setSelectedData(res.data);
      setViewUserDetails(true);
      setOpenDrawer(true);
    });
  };
  const ActiveUserData = (row, active) => {
    setOpenActiveConfirmBox(true);
    setSelectedData(row);
    setActiveBoolean(!active);
  };

  const ActiveFunction = (event) => {
    UpdateUser(selectedData._id, { isEnabled: activeBoolean }).then((res) => {
      // activeBoolean ? GetInActiveData() : GetActiveData();
      GetData();
    });
    setOpenActiveConfirmBox(false);
  };

  return (
    <>
      <Grid container className="Master_Card_Container">
        <Grid
          container
          alignItems={"center"}
          className="Master_Card_Sub_Container"
        >
          <Grid item xs={12} sm={6} md={6}>
            <Typography className="Master_Card_Tittle">User</Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={6}
            className="d-flex justify-content-end"
          >
            <Stack direction="row" spacing={2} justifyContent="flex-end" sx={{ width: "100%" }}>
              {isSuperAdmin ? (
                <Button
                  className="Master_Card_Filter_Button w-100"
                  sx={{ width: "102px", height: "40px", gap: "8px" }}
                  startIcon={
                    <Badge
                      badgeContent={activeFiltersCount}
                      color="error"
                      sx={{
                        "& .MuiBadge-badge": {
                          right: 5,
                          top: 3,
                          width: "14px",
                          height: "14px",
                          minWidth: "14px",
                          borderRadius: "50%",
                          fontSize: "8.91px",
                          fontWeight: "600",
                          backgroundColor: "#E50000",
                          color: "#fff",
                          padding: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        },
                      }}
                    >
                      <FilterListIcon sx={{ marginRight: "1.5px" }} />
                    </Badge>
                  }
                  onClick={() => setShowFilter((s) => !s)}
                >
                  Filters
                </Button>
              ) : null}
              <Button
                className="Master_Card_create_Button w-100"
                startIcon={
                  <AddIcon
                    sx={{
                      marginRight: "1.5px",
                    }}
                  />
                }
                onClick={() => CreateUserData()}
              >
                Create
              </Button>
            </Stack>
          </Grid>
        </Grid>
        {/* Filter Section (toggled), same panel the other list pages use */}
        {isSuperAdmin && showFilter && (
          <Box
            sx={{
              mb: 2,
              overflow: "visible",
              position: "relative",
              zIndex: 1200,
              minHeight: "60px",
              width: "100%",
            }}
          >
            <FilterBox
              filterData={filterBoxData}
              type={"single"}
              handleClearAllState={handleClearAllState}
              handleSaveAllFilter={handleSaveAllFilter}
              horizontalLayout={true}
              hideHeader={true}
              hideInput={true}
              alwaysOpen={true}
              autoApply={false}
            />
          </Box>
        )}
        <Grid item xs={12}>
          <Divider
            sx={{
              backgroundColor: "#EAECF0",
              borderWidth: 1,
            }}
          />
        </Grid>
        <Grid
          container
          alignItems={"center"}
          justifyContent={"space-between"}
          className="Master_Card_Sub_Container"
        >
          <Grid item xs={12} sm={6} />
          <Grid item xs={12} sm={4} md={3.1} mt={{ xs: 2, sm: 0, md: 0 }}>
            <Input
              focused="false"
              className="w-100 Master_Card_Input"
              id="standard-adornment-password"
              onChange={onSearch}
              // onChange={(e) => {
              //   setSearchText(e.target.value);
              //   setPage(0);
              // }}
              disableUnderline={true}
              placeholder="Search User"
              startAdornment={
                <InputAdornment position="start" sx={{ marginRight: "0px" }}>
                  <IconButton aria-label="toggle password visibility">
                    <SearchIcon
                      sx={{
                        fontSize: "20px",
                      }}
                    />
                  </IconButton>
                </InputAdornment>
              }
            />
          </Grid>
        </Grid>
        <MasterCommonTable
          tableConfig={tableConfig}
          data={
            showAdminColumn
              ? visibleRows.map((r) => ({ ...r, adminName: adminNameOf(r.clientId) }))
              : visibleRows
          }
          columns={
            showAdminColumn
              ? [
                  ...headCells,
                  {
                    id: "adminName",
                    placeMent: true,
                    disablePadding: false,
                    label: "Admin",
                    minWidth: "150px",
                  },
                ]
              : headCells
          }
          // isServerSide={true}
          handleEdit={EditUserData}
          handleView={ViewUserData}
          //   handleDelete={DeleteCompanyData}
          handleApprove={ActiveUserData}
          tableTotalCount={filter.fn(user)?.length || 0}
          // tableOutputEvent={tableOutputEvent}
          loading={openLoader}
        />
      </Grid>
      <Drawer
        open={openDrawer}
        sx={{
          zIndex: 100,
        }}
        anchor="right"
        PaperProps={{
          sx: { width: { xs: "100%", sm: "100%" } },
        }}
      >
        {openDrawer ? (
          <AddUser
            setOpenDrawer={setOpenDrawer}
            title={selectedData._id ? "Update" : "Create"}
            GetData={GetData}
            selectedData={selectedData}
            formType={
              viewUserDetails ? "view" : selectedData._id ? "edit" : "add"
            }
          />
        ) : null}
      </Drawer>

      <ConfirmBox
        open={openActiveConfirmBox}
        title={selectedData.isEnabled ? "Inactive" : "Active"}
        content={`Are you sure want to ${
          selectedData.isEnabled ? "Inactive" : "Active"
        }`}
        confirmButton={selectedData.isEnabled ? "Inactive" : "Active"}
        setOpenConfirmBox={setOpenActiveConfirmBox}
        Function={ActiveFunction}
        icon={
          selectedData.isEnabled ? <NotInterestedIcon /> : <DoneOutlineIcon />
        }
        color={selectedData.isEnabled ? "error" : "bule"}
        subContent={
          selectedData.isEnabled
            ? "This action will disable the item, and it won't be accessible until reactivated."
            : "Once activated, this item will be accessible. You can disable it later if needed."
        }
        img={selectedData.isEnabled ? DisabledImage : ActiveImage}
      />
      {/* <Loader open={openLoader} /> */}
    </>
  );
};
export default ManageUser;
